import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";
import { listTagsQueryOptions, tagStatsQueryOptions } from "./useTagsWithCounts";

export function useTagsPrefetch() {
  const queryClient = useQueryClient();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (isLoading || !isAuthenticated) return;
    void queryClient.prefetchQuery(listTagsQueryOptions());
    void queryClient.prefetchQuery(tagStatsQueryOptions());
  }, [isAuthenticated, isLoading, queryClient]);
}
